import script from "./MoleculeCardGoals.vue?vue&type=script&lang=ts&setup=true"
export * from "./MoleculeCardGoals.vue?vue&type=script&lang=ts&setup=true"

import "./MoleculeCardGoals.vue?vue&type=style&index=0&id=70703888&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70703888"]])

export default __exports__